<template>
<!-- TODO This v-if was always false and the box was never showed, so there are many
      untranslated texts, that's why I won't enable it right now -->
  <div
    v-if="false"
    v-tooltip
    class="atom-info d-flex align-self-left mt-1"
    :title="$t(infoTooltip)"
  >
    <img src="@/assets/icons/ico-ico-i.svg" class="mr-1" />
    <span>{{ $t(infoText) }} </span>
  </div>
</template>

<script>
export default {
  props: ["infoText", "infoTooltip"]
};
</script>
